import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter001() {
  return <KbChapterPage slug="chapter-001" />;
}

(Chapter001 as unknown as { path: string }).path = "/theory-album/001";
